var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"status-banner-wrapper"},[_c('Transition',{attrs:{"name":"slide"}},[(_vm.isVisible && _vm.isStaff)?_c('div',{staticClass:"status-banner hideOnPrint",class:{
					'status-banner--offline': _vm.isOffline,
					'status-banner--success': !_vm.isOffline && _vm.isSuccess,
					'status-banner--error': !_vm.isOffline && _vm.isError
				}},[_c('div',{staticClass:"status-banner__content"},[_c('span',{staticClass:"status-banner__text"},[_vm._v(_vm._s(_vm.statusMessage))])])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"progress-wrapper hideOnPrint"},[(_vm.isStaff)?_c('div',{staticClass:"status-banner__progress"},[_c('div',{staticClass:"status-banner__progress-bar",class:{
					'status-banner__progress-bar--loading': _vm.isLoading,
					'status-banner__progress-bar--success': _vm.isSuccess,
					'status-banner__progress-bar--error': _vm.isError
				}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }